<template>
  <div>
      <section>
          <div class="top-nav-div">
              <div class="top-nav-elements">
                  <a href="#" class="link-block-42 w-inline-block">
                      <img :src="require('@/assets/images/NewSelf_Logo.png')"
                          sizes="(max-width: 479px) 100vw, 84.03125px"
                          :srcset="`${require('@/assets/images/NewSelf_Logo-p-500.png')} 500w, ${require('@/assets/images/NewSelf_Logo-p-800.png')} 800w`"
                          loading="lazy" class="image-294">
                  </a>
                  <div class="form-nav-div">
                      <a href="#" class="back-link w-inline-block" @click="goBack">
                          <div class="text-block-507">&lt;-</div>
                      </a>
                      <div class="form-progress-div">
                          <div>
                              <div class="text-block-508">Step <strong>1</strong> of <strong>3</strong> Pre-Qualify</div>
                          </div>
                          <div class="form-precent-div">
                              <div class="text-block-509"><strong>100% </strong>Complete</div>
                          </div>
                      </div>
                  </div>
                  <div class="div-block-1442"></div>
              </div>
          </div>
      </section>
      <section class="section-7">
          <div class="questions-div">
              <div class="question-container">
                  <div class="question-div-2">
                      <div class="text-block-513 end">We're Sorry</div>
                      <div class="form-subs end">{{ displayMessage }}</div>
                      <a href="/" class="button-65 finish w-button">Continue <span class="text-span-172">-&gt;</span></a>
                      <div class="div-block-1492"></div>
                  </div>
              </div>
          </div>
      </section>
      <div style="height:280px"></div>
  </div>
</template>

<script>
export default {
  name: 'LeadDisqualified',
  
  data() {
      return {
          defaultMessages: {
              'validation_error': 'There was an error validating your request.',
              'invalid_order_status': 'Your order status is not valid for this action.',
              'default': 'Based on the information you provided, you currently do not qualify for our programs.'
          }
      }
  },

  computed: {
      displayMessage() {
          // Get the reason and message from query params
          const { reason, message } = this.$route.query;
          
          if (message) {
              // If there's a specific message, use it
              return decodeURIComponent(message);
          } else if (reason && this.defaultMessages[reason]) {
              // If there's a reason with a default message, use that
              return this.defaultMessages[reason];
          } else {
              // Fall back to the default message
              return this.defaultMessages.default;
          }
      }
  },

  created() {
      // Store redirect path if it exists
      if (this.$route.query.redirect) {
          localStorage.setItem('previousPath', decodeURIComponent(this.$route.query.redirect));
      }
  },

  methods: {
      goBack() {
          const previousPath = localStorage.getItem('previousPath');
          if (previousPath) {
              this.$router.push(previousPath);
              localStorage.removeItem('previousPath');
          } else {
              this.$router.push('/');
          }
      }
  }
}
</script>

<style scoped>
.back-link {
  cursor: pointer;
  text-decoration: none;
}
.questions-div {
        padding-top: 30px;
        padding-bottom: 50px;
        max-width: 100%;
        padding-left: 20px;
        padding-right: 20px;
    }
</style>